<span *ngIf="(admin$ | async) as admin;else loadingOrError" attr.aria-label=" {{ 'DEVICE.LABELS.CONFIG_HISTORY.HIST_AUTHOR' | translate }} {{ admin }}"> {{ 'DEVICE.LABELS.CONFIG_HISTORY.HIST_AUTHOR' | translate }} {{ admin }}</span>

<ng-template #loadingOrError>
  <span *ngIf="!error">
    <i class="fa fa-circle-o-notch fa-spin" alt="spin"></i>
  </span>
</ng-template>
